import { SxProps } from '@mui/system';
import { COLORS } from '../../../../../../../common/Styleguide/Common/colors';

export const submissionOverviewTabsSx: SxProps = {
  px: '20px',
  '& > div': {
    overflowX: 'auto !important',
  },
  '& > div > .MuiTabs-indicator': {
    backgroundColor: COLORS.brand[100],
  },
};

export const submissionOverviewTabSx: SxProps = {
  py: '30px',
  px: '20px',
  fontWeight: 700,
  textTransform: 'none',
  fontSize: '20px',
  color: COLORS.white[40],
  '& svg': {
    color: COLORS.white[40],
  },
  '&.MuiButtonBase-root': {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 1,
  },
  '&.Mui-selected': {
    color: COLORS.white[100],
    '& svg': {
      color: COLORS.white[100],
    },
  },
};

export const submissionOverviewTabpanelSx: SxProps = {
  marginTop: '-2px',
  padding: '20px',
  borderRadius: '20px',
  boxShadow: `inset 0 0 0 2px ${COLORS.black[70]}`,
  overflow: 'hidden',
};
